import { gql } from "@apollo/client";

export const CREATE_CLASS_ITEM = gql`
  mutation CreateClassItem($input: ClassItemInput) {
    createClassItem(input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;



export const GET_CLASS_BY_ACADEMIC_YEAR = gql`
  query SelectClass($academicYearId: ID) {
    selectClass(academicYearId: $academicYearId) {
      _id
      className
      gradeId {
        _id
        gradeName
      }
    }
  }
`

export const GET_CLASS_ITEM_PAGINATION = gql`
  query GetClassItemPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $academicYearId: ID
    $gradeId: ID
    $groupId: ID
  ) {
    getClassItemPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      academicYearId: $academicYearId
      gradeId: $gradeId
      groupId: $groupId
    ) {
      data {
        _id
        academicYearId {
          _id
          academicYear
          academicYearInKhmer
        }
        gradeId {
          _id
          gradeName
        }
        groupId {
          _id
          groupKhName
          groupEnName
          isUse
          remark
        }
        items {
          qty
          listMaterialUnitId {
            _id
            barcode
            costPerUnit
            imageSrc
            materialId {
              _id
              isbm
              materialEnName
              materialKhName
              categoryId {
                categoryEnName
                categoryKhName
              }
            }
            remark
            unitId {
              _id
              unitEnName
              unitKhName
            }
          }
        }
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const GET_CLASS_ITEM_BY_GRADE = gql`
  query SelectClassItemByGrade($gradeId: ID, $academicYearId: ID) {
    selectClassItemByGrade(gradeId: $gradeId, academicYearId: $academicYearId) {
      _id
      gradeId {
        gradeName
      }
      academicYearId {
        _id
        academicYear
        academicYearInKhmer
      }
      groupId {
        groupEnName
        groupKhName
      } 
      items {
        listMaterialUnitId {
          _id
          barcode
          costPerUnit
          imageSrc
          materialId {
            _id
            materialEnName
            materialKhName
            isbm
          }
          unitId {
            _id
            unitEnName
            unitKhName
          }
        }
        qty
      }
      remark
    }
  }
`;

export const UPDATE_CLASS_ITEM = gql`
  mutation UpdateClassItem($id: ID!, $input: ClassItemInput) {
    updateClassItem(_id: $id, input: $input) {
      message {
        messageEn
        messageKh
      }
      status
    }
  }
`;

export const DELETE_CLASS_ITEM = gql`
  mutation DeleteClassItem($id: ID!) {
    deleteClassItem(_id: $id) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;
